export function sanitizeUnit(rawUnit) {
    if (rawUnit) {
        return rawUnit.toLocaleLowerCase();
    }
    else {
        throw Error("Attempted to sanitize a unit of value, but the unit was undefined.");
    }
}
//# sourceMappingURL=sanitizeUnit.js.map